<template>
    <div>
        <v-layout wrap>
            <v-flex style="padding: 10px">
                <v-text-field
                        type="text"
                        :label="$t('Tuổi tôm')"
                        :value="shrimpAge"
                        disabled
                ></v-text-field>
            </v-flex>
            <v-flex style="padding: 10px">
                <v-select
                        :items="seedNumber"
                        :label="$t('Số lượng giống')"
                        v-model="crop.seedNumber"
                        name="seedNumber"
                        item-value="categoryId"
                        item-text="categoryName"
                        v-validate="'required'"
                        :data-vv-as="$t('Số lượng giống')"
                        :error-messages="errors.first('seedNumber')"
                        disabled
                />

            </v-flex>
            <v-flex style="padding: 10px">
                <v-select
                        :label="$t('Quy trình nuôi')"
                        :items="lstProcedureWh"
                        item-text="code"
                        item-value="procedureId"
                        v-model="crop.processId"
                        disabled
                />
            </v-flex>
            <v-flex style="padding: 10px">
                <v-select
                        :label="$t('Chọn G')"
                        :items="numberGList"
                        item-text="text"
                        item-value="value"
                        name="numberG"
                        ref="numberG"
                        v-model="item.numberG"
                        v-on:change="onViewProcedure"
                        :disabled="!isEdit"
                />
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <table class="lstTable">
                    <tr>
                        <th width="25%">{{$t('lang.material.materialType')}}</th>
                        <th width="25%">Tên vật tư</th>
                        <th width="25%">Đơn vị</th>
                        <th width="25%">Số lượng theo quy trình</th>
                    </tr>
                    <template v-for="item in lstMaterial">
                        <tr v-if="item.row == 0">
                            <td style="font-weight: bold">{{item.typeName}}</td>
                            <td colspan="3">Không có vật tư</td>
                        </tr>
                        <tr v-else>
                            <td :rowspan="item.row" v-if="item.row != undefined" style="font-weight: bold">
                                {{item.typeName}}
                            </td>
                            <td>{{item.materialName}}</td>
                            <td>{{item.unit}}</td>
                            <td style="text-align: right">{{item.total | currency}}</td>
                        </tr>

                    </template>
                </table>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {areaContants} from "@/constants";
    import axios from "axios";
    import moment from "moment";

    export default {
        name: "CropTabContent",
        props: {
            reqOrdId:{
                type: Number,
                default:()=>{
                    return null;
                }
            },
            crop: {
                type: Object,
                default: () => {
                    return null;
                },
            },
            requestData: {
                type: Object,
                default: () => {
                    return null;
                },
            },
            lstProcedureWh: {
                type: Array,
                default: () => {
                },
            },
/*
            materialTypeSelected: {
                type: Array,
                default: [],
            },
            fromDate: {
                type: String,
                default: () => {
                    return null;
                }
            },
            toDate: {
                type: String,
                default: () => {
                    return null;
                }
            },
*/
            isEdit:{
                type: Boolean,
                default: () =>{
                    return true;
                }
            },
            seedNumber: {
                type: Array,
                default: () => {
                    return null;
                }
            }
        },
        data: () => ({
            numberGList: areaContants.numberGList,
            shrimpAge: 0,
            listProcedureWh: [],
            listG: [],
            lstData: [],
            lstMaterial: [],
            lstMaterialType: [],
            lstProcedureData: [],
            item: {
                procedureId: '',
                numberG: 1
            },
            fromDate:null,
            toDate:null,
            materialTypeSelected:[],
            updateData:false,
            loadProcessData:false,
            waitCalculate:false,
        }),
        computed: {},

        created() {
            this.onViewProcedure();
            this.getTabContent();
        },

        watch: {
            crop: {
                handler(val) {
                    console.log("--- handle crop change ---");
                    console.log(val);
                    this.item.procedureId = val.processId;
                    if(val.numberG == undefined || val.numberG == null){
                        this.item.numberG = 1;
                    } else {
                        this.item.numberG = val.numberG;
                    }
                    this.onViewProcedure();
                },
                deep: true
            },

            requestData: {
                handler(val) {
                    console.log("update request data");
                    this.getTabContent();
                },
                deep: true
            }
        },
        methods: {
            onViewProcedure() {
                this.loadProcessData = false;
                axios.post(process.env.VUE_APP_API_URL + "/procedureWh/detail/" + this.crop.processId, {numberG: this.item.numberG}).then(
                    data => {
                        this.lstProcedureData = data;
                        this.loadProcessData = true;
                        if(this.waitCalculate){
                            this.reCalculate();
                            this.waitCalculate = false;
                        }
                        //this.reCalculate();
                    }
                )
            },

            daySpace(date1, date2) {
                return parseInt((date1.getTime() - date2.getTime()) / (1000 * 3600 * 24));
            },

            getShrimpAge() {
                return this.shrimpAgeByDate(this.crop, new Date());
            },

            shrimpAgeByDate(item, calculateDate) {
                let shrimpAge = 0;
                let dropDate = '';
                if (parseInt(item.pondParent) > 0 && item.dropDateParent != '' && item.dropDateParent != null) {
                    dropDate = moment(String(item.dropDateParent));
                } else if (item.dropDate != '' && item.dropDate != null) {
                    dropDate = moment(String(item.dropDate));
                }
                //console.log(dropDate);
                if (dropDate != '') {
                    let calculateDateMM = moment(String(calculateDate));
                    let endDate = moment(String(calculateDate));
                    if (item.endDate) {
                        endDate = moment(String(item.endDate));
                        if (endDate > calculateDateMM) endDate = calculateDateMM;
                    }
                    //if (endDate > dropDate) {
                    let dates = endDate.diff(dropDate, "days");
                    //console.log(endDate);
                    //console.log(dates);
/*
                    if (dates < 0) {
                        console.log("less than 0:" + dates);
                    }
                    if (dates >= 0) {
                    }
*/
                    shrimpAge = dates;
                    //}
                }
                return shrimpAge;

            },

            getTabContent(){
                console.log("get tabcontent");
                for(let i=0;i<this.requestData.lstCrop.length;i++){
                    if(this.requestData.lstCrop[i].cropId == this.crop.cropId){
                        this.lstMaterial = this.requestData.lstCrop[i].lstMaterial;
                        break;
                    }
                }
                this.shrimpAge = this.getShrimpAge();
            },

            reload(fromDate,toDate,materialTypeSelected){
                this.fromDate = fromDate;
                this.toDate = toDate;
                this.materialTypeSelected = materialTypeSelected;
                if(this.loadProcessData) {
                    this.reCalculate();
                } else {
                    this.waitCalculate = true;
                }
            },

            reCalculate() {
                if(!this.isEdit){
                    console.log("not update");
                    this.getTabContent();
                } else {
                    console.log("update crop data");
                    let procedure = null;
                    let cropDate = new Date(this.crop.startDate);
                    this.lstMaterialType = [];
                    let i, j;
                    for (i = 0; i < this.materialTypeSelected.length; i++) {
                        this.lstMaterialType.push(Object.assign({}, this.materialTypeSelected[i]));
                    }
                    //
                    // calculate by date
                    //
                    for (let i = 0; i < this.lstProcedureWh.length; i++) {
                        if (this.lstProcedureWh[i].procedureId == this.crop.processId) {
                            procedure = this.lstProcedureWh[i];
                            break;
                        }
                    }
                    if (procedure == null) {
                        return;
                    }
                    this.shrimpAge = this.getShrimpAge();
                    let fDate = this.shrimpAgeByDate(this.crop, this.fromDate);
                    let tDate = this.shrimpAgeByDate(this.crop, this.toDate);
                    console.log(this.fromDate+"-"+this.toDate);
                    console.log(fDate+"-"+tDate);
                    //
                    // sum
                    //
                    this.lstMaterial = [];
                    for (i = 0; i < this.lstProcedureData.lstMaterial.length; i++) {
                        this.lstMaterial.push(Object.assign({}, this.lstProcedureData.lstMaterial[i]));
                    }
                    for (i = 0; i < this.lstMaterial.length; i++) {
                        this.lstMaterial[i].total = 0;
                        for (j = 0; j < this.lstProcedureData.lstChildrenDay.length; j++) {
                            let procedureDay = this.lstProcedureData.lstChildrenDay[j];
                            if (procedureDay.shrimpAge >= fDate && procedureDay.shrimpAge <= tDate) {
                                if (procedureDay.data == undefined || procedureDay.data == null || procedureDay.data == "") {
                                    continue;
                                }
                                let data = JSON.parse(procedureDay.data);
                                let count = data[this.lstMaterial[i].materialId];
                                if (count != undefined && count != null && count != "") {
                                    this.lstMaterial[i].total += parseFloat(count);
                                }
                            }
                        }
                        for (let j = 0; j < this.lstProcedureData.lstMotherDay.length; j++) {
                            let procedureDay = this.lstProcedureData.lstMotherDay[j];
                            if (procedureDay.shrimpAge >= fDate && procedureDay.shrimpAge <= tDate) {
                                if (procedureDay.data == undefined || procedureDay.data == null || procedureDay.data == "") {
                                    continue;
                                }
                                let data = JSON.parse(procedureDay.data);
                                let count = data[this.lstMaterial[i].materialId];
                                if (count != undefined && count != null && count != "") {
                                    this.lstMaterial[i].total += parseFloat(count);
                                }
                            }
                        }
                        this.lstMaterial[i].total = parseFloat(this.lstMaterial[i].total.toFixed(2));

                    }
                    //
                    // remove item has total = 0 and not in material type
                    //
                    for (i = this.lstMaterial.length - 1; i >= 0; i--) {
                        if (this.lstMaterial[i].total == 0) {
                            this.lstMaterial.splice(i, 1);
                            continue;
                        }
                        let bRemove = true;
                        for (j = 0; j < this.lstMaterialType.length; j++) {
                            if (this.lstMaterialType[j].categoryId == this.lstMaterial[i].typeId) {
                                bRemove = false;
                                break;
                            }
                        }
                        if (bRemove) {
                            this.lstMaterial.splice(i, 1);
                        }

                    }
                    //
                    // sort by typeId
                    //
                    this.lstMaterial.sort((o1, o2) => {
                        if (o1.typeId == o2.typeId) {
                            return o1.materialName.localeCompare(o2.materialName);
                        } else {
                            return o1.typeId - o2.typeId;
                        }
                    })

                    for (i = 0; i < this.lstMaterialType.length; i++) {
                        this.lstMaterialType[i].count = 0;
                        for (j = 0; j < this.lstMaterial.length; j++) {
                            if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
                                this.lstMaterialType[i].count++;
                            }
                        }
                        if (this.lstMaterialType[i].count == 0) {
                            this.lstMaterial.push({
                                typeId: this.lstMaterialType[i].categoryId,
                                typeName: this.lstMaterialType[i].categoryName,
                                row: 0
                            })
                        } else {
                            for (j = 0; j < this.lstMaterial.length; j++) {
                                if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
                                    this.lstMaterial[j].typeName = this.lstMaterialType[i].categoryName;
                                    this.lstMaterial[j].row = this.lstMaterialType[i].count;
                                    break;
                                }
                            }
                        }

                    }
                    let crop = this.crop;
                    crop.lstMaterial = this.lstMaterial;
                    crop.numberG = this.item.numberG;
                    crop.reqOrdId = this.reqOrdId;
                    //console.log(crop);

                    this.$emit("onload", crop);
                    this.updateData = false;
                }
            }

        },
    };
</script>

<style scoped>
</style>